export enum ActivityType {
  Generic,
  SignUp,
  SignUpUpdate,
  ResetPassword,
  SignIn,
  SignOut,
  RequestOrderCard,
  SuccessOrderCard,
  RequestOrderCardAlternate,
  DownloadIDCard,
  FindDoctor,
  DownloadPlanDocument,
  DownloadFormDocument,
  DownloadAccountDocument,
  DownloadBillingDocument,
  Help,
  Home,
  OpenNotificationsSection,
  DownloadAccessForm,
  SendIDCard,
  EmailAccessForm,
  ViewNotificationDetail,
  NoDownloadCardAvailable,
  AlternateEmailCard,
  ExpandHelp,
  EmailIDCard,
  SendFormDocument,    
  RejectedLogin,
  ClickFaqLink,
  ClickFaqGuide,
  ClickFaqVideo,

  // Sentry Tracking Features
  ExportGroupData,
  GroupView, 
  MemberView,
  GroupSearch,
  MemberSearch,
  ViewSubscriberType,
  BBPFiltering,
  ToggleSortingOrder,
  FooterLinks,
  ContactButton,
}